import {defineMessage, FormattedMessage} from '@pinecast/i18n';
import * as React from 'react';

const messages = {
  required: defineMessage({
    description:
      "Error shown when a value is required but hasn't been provided",
    defaultMessage: 'This field cannot be left blank.',
  }),
};

export function required(value: any): React.ReactNode {
  if (value) {
    return undefined;
  }
  return <FormattedMessage {...messages.required} />;
}

export function noHTML(value: any): React.ReactNode {
  if (value && value.includes('<')) {
    return <FormattedMessage {...messages.required} />;
  }
  return undefined;
}

export function url(value: string): React.ReactNode {
  if (value && !value.match(/^https?:\/\//)) {
    return (
      <FormattedMessage
        description="Error shown when a value is supposed to be a URL but is malformed"
        defaultMessage="URLs must start with http:// or https://."
      />
    );
  }
  return undefined;
}

export function composeValidation(
  ...rules: Array<(value: any) => React.ReactNode | undefined>
) {
  return (value: any) => {
    for (const rule of rules) {
      const result = rule(value);
      if (result) {
        return result;
      }
    }
    return undefined;
  };
}
